import React from 'react'
import './FloatingBar.css';

import {BiHomeAlt2, BiPaint} from 'react-icons/bi';
import {MdOutlineDesignServices} from 'react-icons/md';
import {AiOutlineInfoCircle} from 'react-icons/ai';
import {LuContact} from 'react-icons/lu'


const FloatingBar = () => {
	return (
		<div className="Floating_bar flex_app">
			<a href="#Home"><BiHomeAlt2 className="icons animation"/></a>
			<a href="#About"><AiOutlineInfoCircle className="icons animation"/></a>
			<a href="#Thumbnails"><BiPaint className="icons animation"/></a>
			<a href="#Services"><MdOutlineDesignServices className="icons animation"/></a>
			<a href="#Footer"><LuContact className="icons animation"/></a>
		</div>
	)
}

export default FloatingBar